import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import helpHover from "../Investment/Images/ionic-ios-information-circle-outline.svg";
import claimSettlement from "./Images/Group2388.svg";
import youPay from "./Images/Group3722.svg";
import youGet from "./Images/Group3725.svg";
import downloadBrochure from "./Images/Icon-feather-download.svg";
import InvestmentCompareBox from "./InvestmentCompareBox";
import InvestmentPlanDetalis from "./InvestmentPlanDetalis";
import TaxSaving from "./TaxSaving";
import CircleLoader from "./UtilityComponents/CircleLoader";
import {
    CommaSeprator,
    convertIntoLakh,
    convertIntoLakhWithoutRoundOff,
    convertIntoLakhWithoutZero,
    CountYear,
    decimaNumberFormat,
    formatValueInRupeeFormat,
} from "./UtilityComponents/UtilityFunction";
import { Modal } from "react-bootstrap";
import MaskedInput from "react-text-mask";
import FundAllocationModal from "../components/modals/FundAllocationModal";

const SMCInvestementQuotation = ({
    QuoteData,
    BuyNow,
    IsLoader,
    AddCompareBoxItem,
    BuyNowId,
    IsCallChildFunction,
    PaymentFreq,
    ModelPremium,
    RemoveItemFromCompareBox,
    CompareItem,
    onPlanOptionChange,
    PlanOption,
    isQuoteLoaded,
    selectedQuoteKey,
    handleHiddenQuotes,
    handleAutoPay,
    handleSumAssured,
    btnGST,
    AllQuotes,
    showFundAllocationModal,
    saveFundList,
    payoutFrequencyList,
    payoutFrequencyValue,
    onPayoutFrequencyChange
}) => {
    const [IsCompareShow, setIsCompareShow] = useState(false);
    const [IsTaxShow, setTaxShow] = useState(false);
    const [IsPlanShow, setPlanShow] = useState(false);
    const [sumAssured, setSumAssured] = useState(null);
    const [fundAllocationModal, setFundAllocationModal] = useState(false);
    const [errors, setErrors] = useState({});
    let ref = useRef();


    useEffect(() => {
        //console.log(QuoteData)
        if (IsCallChildFunction) {
            ref.current.checked = false;
        }
    }, [IsCallChildFunction]);
    useEffect(() => {
        setSumAssured(QuoteData.SumAssured);
    }, [QuoteData.SumAssured]);

    const IsCompareOpen = () => {
        let val = IsCompareShow === true ? false : true;
        setIsCompareShow(val);
    };

    const CompareQuotes = (QuoteData, e) => {
      //  QuoteData.TotalTaxSaving = TotalTaxSaving;

        e.target.checked ? AddCompareBoxItem(QuoteData, e) : RemoveItemFromCompareBox(QuoteData.PlanName);
    };

    const handleSubmit = () => {
        let req = {
            produtId: "12072",
            uniqueCode: "151_12072",
            CompanyId: QuoteData?.InsurerId,
            QuotationID: QuoteData?.QuoteID,
        };

        axios.post("https://uat.smcinsurance.com/investmentApi/api/InvestmentPlan/GeneratePDF", req)
            .then((res) => {
                //console.log("Pdf  data", res.data);
                if (res.data.IsSuccess) {
                    window.location.href = res.data.URL;
                }
            })
            .catch((err) => {//console.log(err)
            });
    };

    const submitSumAssured = (e) => {
        if (Number(sumAssured) % 50000 === 0 && (sumAssured != QuoteData.SumAssured) && (Number(sumAssured) >= QuoteData.MinimumTataSumInsured)) {
            handleSumAssured(sumAssured)
        }
    }

    const handleSumAssuredValue = (e) => {

        const onlyNums = e.target.value.replace(/[^0-9]/g, '');
        // Disallow leading zero
        if (onlyNums.length === 0 || onlyNums[0] !== '0') {
            if (onlyNums.length <= 9) {
            const inputValue = onlyNums;
        setSumAssured(inputValue);
        // Check if the value is a multiple of 50000
        if (inputValue === "" || Number(inputValue) % 50000 !== 0) {
            setErrors({ ...errors, sumAssured: "Value should be multiple of 50000" });
        } else if (Number(inputValue) < QuoteData?.MinimumTataSumInsured) {
            setErrors({ ...errors, sumAssured: `Value should not be less than ${QuoteData?.MinimumTataSumInsured}` });
        } else {
            setErrors({ ...errors, sumAssured: "" });
                }

            }
        }
    };
    const showPayoutFrequency = (String(QuoteData?.PlanId) === "52" || String(QuoteData?.PlanId) === "56")
        && QuoteData?.QuoteStatus
        && Array.isArray(payoutFrequencyList)
        && payoutFrequencyList.length > 0;
    return (
        <>
            <section className="InvestmentQuoteRow" style={{pointerEvents: QuoteData?.TatalInvestmentAmount ? "auto" : "none"}}>
                <div className="InvestmentHead">
                    <p>{QuoteData?.PlanName}</p>
                </div>
                {AllQuotes.length > 1 &&<div className="IconContainer">
                    <small className="hideIcon_EyeInfo" onClick={() => handleHiddenQuotes(QuoteData.PlanId)}><i className="fas fa-minus-circle"></i><span></span></small>
                </div>}
                <div className="InvestmentMedium">
                    <div className="InvstRight">
                        <div className="Qlogo" style={{ paddingTop: "10px" }}>
                            <img src={QuoteData?.Image} />
                            {QuoteData.PlanOptionList && Array.isArray(QuoteData.PlanOptionList) && QuoteData.PlanOptionList.length > 0 && <p style={{ paddingTop: "5px" }}> <select className="DrpDwn" value={PlanOption} onChange={e => onPlanOptionChange(parseInt(e.target.value))} >
                                {QuoteData.PlanOptionList.map(r => < option value={r.Value} >{r.Key}</option>)}
                            </select></p>}
                            {showPayoutFrequency && (
                                <div style={{ paddingTop: "5px" }}>
                                    <p className="mb-0">Payout Frequency</p>
                                    <select
                                        className="DrpDwn"
                                        value={payoutFrequencyValue ?? ""}
                                        onChange={(e) => onPayoutFrequencyChange?.(e.target.value)}
                                    >
                                        {payoutFrequencyList.map((r) => (
                                            <option key={r.Value} value={r.Value}>{r.Key}</option>
                                        ))}
                                    </select>
                                </div>
                            )}
                            {QuoteData.InsurerId === 156 &&
                                <div>
                                    <p>Enter Sum Insured</p>
                                <div className="tata_sumIns">
                                   
                                    <input
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        type="text"
                                        className="inputText"
                                        maxLength="14"
                                        name="sumAssured"
                                        //placeholder="Enter sum insured"
                                        value={formatValueInRupeeFormat(sumAssured)}
                                        onBlur={submitSumAssured}
                                        onChange={handleSumAssuredValue}

                                        />
                                        <p className="convert_lakhBox">{convertIntoLakhWithoutRoundOff(sumAssured)}</p>
                                    <span className="Error-Text mt-2">{errors?.sumAssured}</span>
                                </div>
                                </div>
                            }
                        </div>
                        <div className="InvestMobile">
                            <p className="GuaranteedBenefit">
                                Guaranteed benefit:{" "}
                                {!QuoteData?.IsLoader && <b>₹{convertIntoLakh(parseInt(QuoteData?.GuaranteedMaturityBenefit))}</b>}
                            </p>
                            <p className="GuaranteedBenefit">
                                Risk benefit:{" "}
                                {!QuoteData.IsLoader && <b> ₹{convertIntoLakh(parseInt(QuoteData?.DeathBenefit))} /1st Year
                                </b>
                                }
                            </p>
                        </div>
                    </div>
                    <div className="InvstLeft">
                        <div className="YouPay">
                            <img src={youPay} className="IconPic" />
                            <div>
                                <p className="GuaranteedBenefit">
                                    You pay till:{" "}
                                    {CountYear(QuoteData?.PaymentTerm)}{" "}
                                </p>
                                <p className="GuaranteedBenefit">
                                    {" "}
                                    {!QuoteData?.IsLoader && <><b>
                                        ₹{convertIntoLakh(QuoteData?.TatalInvestmentAmount)}
                                    </b>
                                        &nbsp;in {QuoteData?.PaymentTerm} Years</>
                                    }{" "}
                                </p>
                            </div>
                        </div>
                        <div className="YouGet">
                            <img src={youGet} className="IconPic" />
                            <div>
                                <p className="GuaranteedBenefit">
                                    You get in {QuoteData?.PolicyTerm ?  CountYear(QuoteData?.PolicyTerm) :""}{" "}
                                </p>
                                <p className="GuaranteedBenefit">
                                    {!QuoteData?.IsLoader && <b>
                                        ₹{convertIntoLakh(parseInt(QuoteData?.MaturityBenefit))}{" "}
                                    </b>
                                    }
                                </p>
                                {QuoteData.CompanyID === 151 ? (
                                    <p className="GuaranteedBenefit">Maturity benefit @ 8%</p>
                                ) : null}
                            </div>
                        </div>
                        <div className="InvestMobileButton">
                            <button
                                className="QuoteBtn"
                                disabled={IsLoader}
                                onClick={() => BuyNow(QuoteData)}
                            >
                                {(QuoteData?.IsLoader || QuoteData.TranKey==selectedQuoteKey) ? (
                                    <CircleLoader />
                                ) : (
                                    <>
                                            <span className="InvestNow">Invest Now</span>₹{CommaSeprator(decimaNumberFormat(btnGST ? QuoteData.TotalPremium: QuoteData?.NetPremium))} <span className="PerYearText">{/*QuoteData?.PaymentFreq*/}</span>
                                    </>
                                )}
                            </button>
                            <span className="PerYearText">{QuoteData?.PaymentFreq === "Y" ? "Yearly" : QuoteData?.PaymentFreq === "M" ? "Monthly" : QuoteData?.PaymentFreq === "Q" ? "Quarterly" : QuoteData?.PaymentFreq === "H" ? "Half Yearly" : ""}</span>
                            <div className="PerMonthVal">
                                {!QuoteData?.IsLoader ? (
                                    ""
                                ) : (
                                    <span>
                                        {PaymentFreq === "Y"
                                            ? "Yearly"
                                            : PaymentFreq === "M"
                                                ? "Monthly"
                                                : PaymentFreq === "Q"
                                                    ? "Quarterly"
                                                    : PaymentFreq === "H"
                                                        ? "Half Yearly"
                                                        : ""}
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="InvestmentBottom">
                    <div className="InvestBottomDetails">
                        {AllQuotes.length >1 && < div className="CompareBox">
                            <label className="CompareCheck">
                                <input
                                    className="checkCompare ng-pristine ng-untouched ng-valid ng-empty"
                                    name="compareBox"
                                    value=""
                                    type="checkbox"
                                    checked={CompareItem.filter(r => r.PlanName === QuoteData.PlanName).length > 0}
                                    ref={ref}
                                    onChange={(e) => CompareQuotes(QuoteData, e)}
                                />
                                <span className="checkmarkCom"></span> <b>Compare</b>
                            </label>
                        </div>}

                        <div className="CSRText">
                            <img src={claimSettlement} className="IconPic mx-1" />
                            <span className="claimSettlementRatio">
                                {QuoteData?.ClaimSettlementRatio} Claim settlement ratio
                            </span>
                        </div>
                        {QuoteData.InsurerId === 156 && <div className="DwnLoadText">
                            <span className="InvestFormats" onClick={() => setFundAllocationModal(true)}>
                                Fund Allocation
                            </span>
                        </div>}
                        <div>
                            {IsLoader ?(
                                <div className="InvestFormats">
                                    <span className="mb-0">Tax savings </span>
                                    <img src={helpHover} className="IconPic taxSavingIcon" alt="More info." />
                                </div>
                            ) : (
                                <div
                                    className="InvestFormats taxSaving"
                                    onClick={() => setTaxShow(!IsTaxShow)}
                                >
                                        <span className="mb-0 ">Tax savings ₹{CommaSeprator(decimaNumberFormat(QuoteData.TotalTaxSaving))}</span>
                                        <img src={helpHover} className="IconPic taxSavingIcon" alt="More info." />

                                </div>
                            )}
                        </div>
                        {IsLoader ? (
                            <div className="DwnLoadText">
                                <span className="InvestFormat">Download brochure</span>
                                <img src={downloadBrochure} className="IconPic" />
                            </div>
                        ) : (
                            <>

                                {QuoteData?.PDFUrl && <div className="DwnLoadText BenefitIllustration">
                                    <a href={QuoteData?.PDFUrl} target="_blank">
                                        <span className="InvestFormat">Benefit illustration</span>
                                        <img src={downloadBrochure} className="IconPic" />
                                    </a>
                                </div>}
                                <div className="DwnLoadText Brochure">
                                    <a href={QuoteData?.BrochureUrl} target="_blank">
                                        <span className="InvestFormat">Brochure</span>
                                        <img src={downloadBrochure} className="IconPic" />
                                    </a>
                                    </div>

                                    {QuoteData.InsurerId === 156 && <div className="autopay_Payment">
                                        <label>
                                            <input type="checkbox" checked={QuoteData?.IsAutoPay} style={{accentColor:"#green"}}  onChange={() => handleAutoPay(QuoteData.IsAutoPay ? false : true)} />
                                            <span> Autopay Payment</span>
                                        </label>
                                        <p className="">Get {QuoteData?.AutoPayDiscount}% discount</p>
                                    </div>}

                            </>
                        )}
                        <div className="mx-3">
                            <button
                                className="PlanDetails"
                                disabled={IsLoader}
                                onClick={() => setPlanShow(!IsPlanShow)}
                            >
                                Plan Details
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            <Modal show={fundAllocationModal} className="IsEditSideDetails fundAllocationModal" dialogClassName="custom-modal-width">
                <FundAllocationModal InsurerId={QuoteData.InsurerId} selectedFunds={QuoteData?.fundListResponse} onClose={() => setFundAllocationModal(false)} handleSubmit={(funds) => saveFundList(funds)} />
            </Modal>


            {IsCompareShow && <InvestmentCompareBox />}
            {IsTaxShow && (
                <TaxSaving
                    ClosePopup={(data) => setTaxShow(data)}
                    QuoteData={QuoteData}
                    TotalTaxSaving={QuoteData.TotalTaxSaving}
                    TaxSlab={QuoteData.ThirtyTaxSlab}
                    CessAmount={QuoteData.TaxSavingTenYear}
                    TaxSlabAmount={QuoteData.TotalTexSaving}
                    fourCess={QuoteData.fourcess}
                    TaxSlabAmount10D={QuoteData.TexSavingonReturn}
                />
            )}
            {IsPlanShow && (
                <Modal show={IsPlanShow} className="customeName">
                    <InvestmentPlanDetalis
                        ClosePopup={(data) => setPlanShow(data)}
                        QuoteData={QuoteData}
                        BuyNow={() => BuyNow(QuoteData)}
                    />
                </Modal>
            )}
        </>
    );
};
export default SMCInvestementQuotation;
